<ion-card>
  <ion-card-header>
    <ion-card-title>Wifi eszközök (MAC-engedélyezőlista)</ion-card-title>
    <ion-card-subtitle>
      A hálózati eszköz ebből a listából engedi a gépeket a wifire, VLAN szerint.
      A felhasználók a saját eszközüket bejelentik, itt kell elbírálni.
      <b>Diák → {{ vlanSzabaly.tanulo }}-es VLAN, dolgozó → {{ vlanSzabaly.dolgozo }}-es VLAN;</b>
      gondviselő nem jelenthet be eszközt. A VLAN-t a szerepkör adja, nem a kérelmező.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>

    <!-- Állapot-fülek: a kérelmekkel indulunk, mert az a teendő -->
    <div class="fulek">
      <button [class.aktiv]="szuroStatusz === 'kerelem'" (click)="szuroValt('kerelem')">
        Elbírálásra vár <b>{{ osszesites.kerelem || 0 }}</b>
      </button>
      <button [class.aktiv]="szuroStatusz === 'jovahagyva'" (click)="szuroValt('jovahagyva')">
        Jóváhagyva <b>{{ osszesites.jovahagyva || 0 }}</b>
      </button>
      <button [class.aktiv]="szuroStatusz === 'elutasitva'" (click)="szuroValt('elutasitva')">
        Elutasítva <b>{{ osszesites.elutasitva || 0 }}</b>
      </button>
      <button [class.aktiv]="szuroStatusz === ''" (click)="szuroValt('')">Összes</button>
      <span class="vlan-info">
        aktív: VLAN {{ vlanSzabaly.dolgozo }} – <b>{{ osszesites.vlan10 || 0 }}</b> ·
        VLAN {{ vlanSzabaly.tanulo }} – <b>{{ osszesites.vlan20 || 0 }}</b>
      </span>
      <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>
    </div>

    <div class="fejsor">
      <ion-input fill="outline" placeholder="Keresés: MAC, eszköznév, felhasználó"
                 [(ngModel)]="kereses" (keyup.enter)="betolt()" style="max-width:340px"></ion-input>
      <ion-button size="small" fill="outline" (click)="betolt()">
        <ion-icon slot="icon-only" name="search"></ion-icon>
      </ion-button>
      <ion-button size="small" fill="outline" (click)="ujNyitva = !ujNyitva">
        <ion-icon slot="start" name="add"></ion-icon>Kézi felvétel
      </ion-button>
    </div>

    <!-- Kézi felvétel: nyomtató, projektor – ahol nincs kérelmező -->
    <div class="uj-doboz" *ngIf="ujNyitva">
      <ion-input fill="outline" label="MAC-cím" labelPlacement="stacked"
                 placeholder="A1:B2:C3:D4:E5:F6" [(ngModel)]="uj.mac"></ion-input>
      <ion-input fill="outline" label="Eszköz neve" labelPlacement="stacked"
                 placeholder="pl. Tanári nyomtató" [(ngModel)]="uj.device_name"></ion-input>
      <ion-select fill="outline" label="VLAN" labelPlacement="stacked" interface="popover"
                  [(ngModel)]="uj.vlan_id">
        <ion-select-option [value]="vlanSzabaly.dolgozo">{{ vlanSzabaly.dolgozo }} – dolgozói</ion-select-option>
        <ion-select-option [value]="vlanSzabaly.tanulo">{{ vlanSzabaly.tanulo }} – diák</ion-select-option>
      </ion-select>
      <ion-input fill="outline" label="Megjegyzés" labelPlacement="stacked" [(ngModel)]="uj.megjegyzes"></ion-input>

      <!-- Gazda megadása felvételkor. Nem kötelező: nyomtatónak, projektornak nincs. -->
      <div class="hozzarendeles">
        <span class="cimke">Kihez tartozik?</span>
        <b *ngIf="uj.igenylo">{{ uj.igenylo_nev || uj.igenylo }}</b>
        <span class="halvany" *ngIf="!uj.igenylo">nincs megadva (nyomtató, projektor)</span>
        <ion-button size="small" fill="outline" (click)="hozzarendelesNyit('uj')">
          {{ uj.igenylo ? 'Csere' : 'Kiválasztás' }}
        </ion-button>
        <ion-button size="small" fill="clear" color="medium" *ngIf="uj.igenylo"
                    (click)="uj.igenylo=''; uj.igenylo_nev=''; uj.igenylo_mod=''">Törlés</ion-button>
      </div>

      <ion-button size="small" color="success" (click)="ujFelvetel()">Felvétel</ion-button>
    </div>

    <!-- Személyválasztó: kereshető, névsorban. Ugyanaz a kör, mint a rendszer többi
         helyén – dolgozók és tanulók, aktív jogviszonnyal. -->
    <div class="szemelyvalaszto" *ngIf="hozzarendelesSor">
      <ion-searchbar [(ngModel)]="szemelySzuro" placeholder="Név vagy azonosító…"
                     show-clear-button="focus"></ion-searchbar>
      <ion-list lines="full" class="szemelylista">
        <ion-item *ngFor="let sz of szurtSzemelyek" button="true" (click)="szemelytValaszt(sz)">
          <ion-label>
            <h3>{{ sz.nev }}</h3>
            <p>{{ tipusNev(sz.tipus) }}<span *ngIf="sz.reszlet"> · {{ sz.reszlet }}</span></p>
          </ion-label>
        </ion-item>
        <ion-item *ngIf="!szurtSzemelyek.length"><ion-label class="halvany">Nincs találat.</ion-label></ion-item>
      </ion-list>
      <ion-button size="small" fill="clear" color="medium" (click)="hozzarendelesSor = null">Mégse</ion-button>
    </div>

    <!-- Tömeges elbírálás -->
    <div class="dontes-sav" *ngIf="kijelolt.length">
      <b>{{ kijelolt.length }} kijelölve</b>
      <ion-button size="small" color="success" (click)="dontes('jovahagy')">
        <ion-icon slot="start" name="checkmark-outline"></ion-icon>Jóváhagyás
      </ion-button>
      <ion-input fill="outline" placeholder="Elutasítás indoka (a felhasználó látja)"
                 [(ngModel)]="elutasitasIndok" style="min-width:260px"></ion-input>
      <ion-button size="small" color="danger" (click)="dontes('elutasit')">
        <ion-icon slot="start" name="close-outline"></ion-icon>Elutasítás
      </ion-button>
    </div>

    <div class="tabla-doboz">
      <table class="mac-tabla">
        <thead>
          <tr>
            <th style="width:28px">
              <input type="checkbox" [checked]="mindKijelolve"
                     (change)="mindKijelol($any($event.target).checked)" />
            </th>
            <th>MAC-cím</th>
            <th>Eszköz</th>
            <th>Kérelmező</th>
            <th>VLAN</th>
            <th>Állapot</th>
            <th>Aktív</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of eszkozok">
            <td><input type="checkbox" [checked]="kijelolve(e.id)"
                       (change)="kijelolValt(e.id, $any($event.target).checked)" /></td>
            <td class="mac">{{ e.mac_formazott }}</td>
            <td>
              {{ e.device_name || '–' }}
              <div class="alsor" *ngIf="e.megjegyzes">{{ e.megjegyzes }}</div>
              <div class="alsor" *ngIf="e.operating_system">{{ e.operating_system }}</div>
            </td>
            <td>
              <!-- A NÉV az elsődleges: egy azonosítóból nem lehet megmondani, kihez
                   tartozik a gép – pedig épp ez a kérdés. -->
              <b *ngIf="e.igenylo_nev">{{ e.igenylo_nev }}</b>
              <span *ngIf="!e.igenylo_nev">{{ e.igenylo || e.user_principal_name || '–' }}</span>
              <div class="alsor" *ngIf="e.igenylo_nev && e.igenylo">{{ e.igenylo }}</div>
              <div class="alsor" *ngIf="e.igenylo_mod">
                {{ tipusNev(e.igenylo_mod) }}
                <span class="figyelmeztet" *ngIf="vlanElter(e)"
                      title="A mód szerinti VLAN eltér a beállítottól">· VLAN eltér</span>
              </div>
              <div class="alsor" *ngIf="e.forras === 'kezi'">kézi felvétel</div>
              <div class="alsor">
                <a class="hivatkozas" (click)="hozzarendelesNyit(e)">
                  {{ e.igenylo ? 'átrendelés' : 'hozzárendelés' }}
                </a>
                <a class="hivatkozas" *ngIf="e.igenylo" (click)="hozzarendelesTorol(e)"> · levétel</a>
              </div>
            </td>
            <td>
              <select [ngModel]="e.vlan_id" (ngModelChange)="vlanValt(e, $event)" class="vlan-valaszto">
                <option [ngValue]="null">–</option>
                <option [ngValue]="vlanSzabaly.dolgozo">{{ vlanSzabaly.dolgozo }}</option>
                <option [ngValue]="vlanSzabaly.tanulo">{{ vlanSzabaly.tanulo }}</option>
              </select>
            </td>
            <td>
              <ion-badge [color]="allapotSzin(e.statusz)">{{ allapotNev(e.statusz) }}</ion-badge>
              <div class="alsor" *ngIf="e.elbiralas_indok">{{ e.elbiralas_indok }}</div>
            </td>
            <td>
              <ion-toggle [checked]="e.enabled === 1" (ionChange)="engedelyValt(e)"></ion-toggle>
            </td>
            <td>
              <ion-button size="small" fill="clear" color="danger" (click)="torles(e)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!eszkozok.length && !toltodik">
        Nincs megjeleníthető eszköz ebben a nézetben.
      </div>
    </div>
  </ion-card-content>
</ion-card>
